"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[天枢] Route Error:", error.message, error.digest);
  }, [error]);

  return (
    <div className="flex items-center justify-center h-full p-8">
      <div className="text-center space-y-4 max-w-md">
        <div className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center bg-amber-50 border border-amber-200">
          <svg className="w-8 h-8 text-amber-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-2">页面出错了</h2>
          <p className="text-sm text-gray-500">
            {error.message || "该页面加载时遇到问题"}
          </p>
        </div>
        <button
          onClick={() => reset()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#2563EB] text-white text-sm hover:bg-[#1d4ed8] transition-colors"
        >
          重试
        </button>
      </div>
    </div>
  );
}
